export const SAMPLE_IDS = ["paper", "signal", "cloud", "tide", "studio"];
export function isSampleId(value) {
    return SAMPLE_IDS.includes(value);
}
const unsplash = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&q=86`;
function srcset(base) {
    return [1280, 1920, 2560, 3840].map((w) => `${base}&w=${w} ${w}w`).join(", ");
}
export const SAMPLE_THEMES = {
    paper: {
        id: "paper",
        number: 1,
        name: "Paper",
        pitch: "Warm oatmeal and rust. Notebook energy.",
        headline: ["Stay with the", "conversation."],
        subhead: "Live copilot and meeting notes on Mac or Windows. No bot in the room.",
        logo: "paper",
        page: "#F4EFE6",
        ink: "#2A2218",
        muted: "rgba(42,34,24,0.58)",
        card: "#FFFBF4",
        border: "rgba(196,92,38,0.18)",
        cta: "#C45C26",
        ctaText: "#FFFBF4",
        ghost: "rgba(196,92,38,0.12)",
        display: "evyely-display",
        hero: {
            src: `${unsplash("photo-1455390582262-044cdead277a")}&w=2560`,
            srcSet: srcset(unsplash("photo-1455390582262-044cdead277a")),
            alt: "Notebook and pen on a wooden desk",
            fade: "linear-gradient(180deg, rgba(244,239,230,0.2) 0%, #F4EFE6 88%)",
        },
        theater: "paper",
    },
    signal: {
        id: "signal",
        number: 2,
        name: "Signal",
        pitch: "Black and lime. Overlay-first, night mode.",
        headline: ["Help in the call.", "A file after."],
        subhead: "Desktop overlay. Transcript as You and Them. Notes as PDF.",
        logo: "signal",
        page: "#070707",
        ink: "#F4F4F0",
        muted: "rgba(244,244,240,0.58)",
        card: "#111111",
        border: "rgba(200,255,61,0.18)",
        cta: "#C8FF3D",
        ctaText: "#070707",
        ghost: "rgba(255,255,255,0.08)",
        display: "font-semibold tracking-tight",
        theater: "signal",
    },
    cloud: {
        id: "cloud",
        number: 3,
        name: "Cloud",
        pitch: "White and cyan. Airy, consumer, lots of space.",
        headline: ["The copilot that", "stays on your side."],
        subhead: "Interview help and meeting notes on your computer. Nothing joins the call.",
        logo: "cloud",
        page: "#F7FAFF",
        ink: "#0B1B33",
        muted: "rgba(11,27,51,0.58)",
        card: "#FFFFFF",
        border: "rgba(59,158,255,0.22)",
        cta: "#3B9EFF",
        ctaText: "#FFFFFF",
        ghost: "rgba(59,158,255,0.1)",
        display: "font-semibold tracking-tight",
        hero: {
            src: `${unsplash("photo-1534088568595-a066f410bcda")}&w=2560`,
            srcSet: srcset(unsplash("photo-1534088568595-a066f410bcda")),
            alt: "Soft clouds in a pale sky",
            fade: "linear-gradient(180deg, rgba(247,250,255,0.15) 0%, #F7FAFF 90%)",
        },
        theater: "cloud",
    },
    tide: {
        id: "tide",
        number: 4,
        name: "Tide",
        pitch: "Teal and silver. Calm professional glass.",
        headline: ["Hear it.", "Keep the note."],
        subhead: "System-audio transcript, screen-aware answers, PDF notes. Mac and Windows.",
        logo: "tide",
        page: "#F3F7F6",
        ink: "#04151A",
        muted: "rgba(4,21,26,0.58)",
        card: "#FFFFFF",
        border: "rgba(26,107,92,0.18)",
        cta: "#0B3D4A",
        ctaText: "#F3FBFF",
        ghost: "rgba(11,61,74,0.08)",
        display: "evyely-display",
        hero: {
            src: `${unsplash("photo-1507525428034-b723cf961d3e")}&w=2560`,
            srcSet: srcset(unsplash("photo-1507525428034-b723cf961d3e")),
            alt: "Quiet shoreline in cool light",
            fade: "linear-gradient(180deg, rgba(243,247,246,0.12) 0%, #F3F7F6 90%)",
        },
        theater: "tide",
    },
    studio: {
        id: "studio",
        number: 5,
        name: "Studio",
        pitch: "Product page. Laptop overlay. Current aubergine-gold logo. Ready to become the live site.",
        headline: ["Runs on your computer.", "Not in the meeting."],
        subhead: "If you like this page, we can replace the entire product look with it.",
        logo: "aubergine",
        page: "#16140F",
        ink: "#F3EFE4",
        muted: "rgba(243,239,228,0.55)",
        card: "#1A160E",
        border: "rgba(214,169,79,0.28)",
        cta: "#D6A94F",
        ctaText: "#16140F",
        ghost: "rgba(255,255,255,0.06)",
        display: "evyely-display",
    },
};
